export default __webpack_public_path__ + "static/media/userExperienceLogo.5d5bb02a.svg";